import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import Cell from '../../Cell/Cell';
import InfoTablo from '../../InfoTablo/InfoTablo';
import { ReactComponent as CallIcon } from '../../../../../resource/CallIcon.svg';
import { notDraggableClass } from '../../../constants/common';
import useSipStates from '../../../../../hooks/useSipStates';
import { setCallDirection, setSubscriber } from '../../../store/actions';
import { callDirections } from '../../../constants/callDirections';
import { SipPhoneContext } from '../../../../../components/SipPhoneProvider';
import { formatPhoneNumber } from '../../../../../helpers/formatPhoneNumber';
import { phoneQueryKeys } from '../../../queries/queryKeys';
import { actions as newRequestAction } from '../../../../../containers/CreateRequest/new-request.actions';

const ActiveCalls = ({ blockInstallationOwnerData }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { startCall } = useContext(SipPhoneContext);

  const { isIdle } = useSipStates();

  const calls = queryClient.getQueryData(phoneQueryKeys.calls());
  const activeCalls = calls?.activeCalls;

  const sortedActiveCalls = useMemo(() => {
    return [...(activeCalls || [])].sort((a, b) => b.waitSecond - a.waitSecond);
  }, [activeCalls]);

  const handleRowClick = (item) => {
    const num = formatPhoneNumber({ phoneNumber: item.callerIdNum });
    const fullName = item?.masterData?.fullName || item?.clientData?.name || '';

    if (num) {
      dispatch(
        setSubscriber({
          phone: item.phone,
          serviceCompany: item.serviceCompany,
        })
      );
      dispatch(setCallDirection(callDirections.incomming));
      startCall(`#${num}`);
      if (!blockInstallationOwnerData) {
        dispatch(newRequestAction.setOwnerData(fullName, num));
        dispatch(newRequestAction.applyAddrServiceCompany(item.companyId));
      }
    }
  };

  return (
    <Cell
      className={notDraggableClass}
      title="Абоненты в очереди:"
      content={
        <InfoTablo
          insert
          onRowClick={isIdle ? handleRowClick : undefined}
          items={
            Boolean(sortedActiveCalls?.length)
              ? sortedActiveCalls.map((call) => ({
                  ...call,
                  iconType: 'call',
                  renderIcon: ({ className }) => (
                    <CallIcon className={className} />
                  ),
                }))
              : []
          }
        />
      }
    />
  );
};

export default ActiveCalls;
